import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import { ButtonsContainer } from './styled-components'
import useCreateContractModalStyles from './useCreateContractModalStyles'

const ModalButtons = ({ onCancel, onConfirm, disabled, hidden }) => {
  const { t } = useTranslation()
  const { isPulse, cancelButtonKind, cancelButtonOverrides, confirmButtonOverrides } = useCreateContractModalStyles()
  if (hidden) {
    return null
  }
  return (
    <ButtonsContainer $pulse={isPulse}>
      <SDButton kind={cancelButtonKind} onClick={onCancel} overrides={cancelButtonOverrides}>
        {t('subscriptionForm:contract_modal.cancel_button')}
      </SDButton>
      <SDButton disabled={disabled} onClick={onConfirm} overrides={confirmButtonOverrides}>
        {t('subscriptionForm:contract_modal.confirm_button')}
      </SDButton>
    </ButtonsContainer>
  )
}

ModalButtons.propTypes = {
  hidden: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

export default ModalButtons
